import * as yup from 'yup'

export const createDiscountSchema = yup.object().shape({
    partner_id: yup.string().required("Выберите партнера"),
    accrual_type: yup.number().required("Выберите тип начисления"),
    value: yup.number().typeError('Укажите число').required("Укажите значение скидки"),
    started_date: yup.date().required('Выберите дату начала скидки'),
    finished_date: yup.date().nullable(),
    priority: yup.number().typeError('Укажите число').required("Укажите приоритет скидки"),
    oem_groups: yup.array().of(yup.number()).required('Выберите категории товаров')
})

export const updateDiscountSchema = yup.object().shape({
    partner_id: yup.string().required("Выберите партнера"),
    accrual_type: yup.number().required("Выберите тип начисления"),
    value: yup.number().typeError('Укажите число').required("Укажите значение скидки"),
    started_date: yup.date().required('Выберите дату начала скидки'),
    finished_date: yup.date().nullable(),
    priority: yup.number().typeError('Укажите число').required("Укажите приоритет скидки"),
    oem_groups: yup.array().of(yup.number()).required('Выберите категории товаров')
})

